<template>
  <div></div>
</template>

<script>
import auth from '../auth'

export default {
  name: 'Callback',
  created () {
    auth.loginCallback()
  }
}
</script>
